import StripeConfiguration from './StripeConfiguration';

export default StripeConfiguration;
